import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { MySandvikFeatures } from 'root/services/permission';
import { ContactUsService, LocalizationService, AuthService, PermissionPolicy, PermissionService, FrontendContextService } from 'root/services';
import { ActivatedRoute, Router } from "@angular/router";
import { MibpSessionService } from "root/services/mibp-session/mibp-session.service";

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpResourceStringAttributesDirective } from 'root/directives/mibp-resource-string/mibp-resource-string-attributes.directive';


@Component({
  styles: [`
    .url {
      color: #ff6a00;
    }
  `],
  template: `
  <h1 class="my-header my-header--nomargin">401</h1>
  <h2 class="my-header"><mibp-resource-string key="Error_UnauthorizedPage_Subtitle"></mibp-resource-string></h2>
  <div class="my-body">
    @if (url) {
      <p class="url">{{ url }}</p>
    }
    <p><mibp-resource-string key="Error_UnauthorizedPage_Message"></mibp-resource-string></p>
  </div>
  
  @if (loggedIn && actingAs) {
    @if (contactUsEnabled) {
      <button type="button" class="my-button" (click)="contactUs()"><mibp-resource-string key="Global_ContactUs"></mibp-resource-string></button>
    } @else {
      <span [mibpResourceStringAttributes]="{ title: 'ContactUs_SupportRepresentativeTooltip' }"><mibp-resource-string key="Global_ContactUs"></mibp-resource-string></span>
    }
  }
  
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, MibpResourceStringAttributesDirective]
})
export class ErrorUnauthorizedPageComponent implements OnInit {
  private contactUsService = inject(ContactUsService);
  private localizationService = inject(LocalizationService);
  private route = inject(ActivatedRoute);
  private permissionService = inject(PermissionService);
  private router = inject(Router);
  private sessionService = inject(MibpSessionService);
  private authService = inject(AuthService);
  protected contactUsEnabled = inject(FrontendContextService).testPermission({ features: [MySandvikFeatures.ContactUsForm] });


  url: string;
  loggedIn: boolean;
  actingAs: boolean;

  ngOnInit(): void {
    const failedPermission = this.route.snapshot.queryParams.p;
    const failedUrl = this.route.snapshot.queryParams.url;

    // Hide Contact Us URL from unauthorized page
    const isContactUsUnauthorized =   
      typeof failedUrl === 'string' &&
      failedUrl.toLowerCase().includes('/support/contact');

    if (!this.authService.getAccessToken()|| isContactUsUnauthorized) {
      this.url = '';
    } else {
      this.url = failedUrl?.toString() ?? '';
    }
    
    this.loggedIn = this.sessionService.isLoggedIn();
    this.actingAs = !!this.sessionService.current?.activeDeliverySequence;

    // If user is logged in and we have permission policy in url, then redirect user to
    // original page if permissions are ok
    if (this.loggedIn && failedPermission) {
      try {
        const permissionPolicy = JSON.parse(atob(failedPermission)) as PermissionPolicy;
        if (this.permissionService.test(permissionPolicy)) {
          this.router.navigateByUrl(failedUrl);
        }
      } catch {
        // Ignore errors
      }
    }


  }
  contactUs(): void {

    let message = this.localizationService.get('Error_UnauthorizedPage_Subtitle');
    if (this.url) {
      message += " - " + this.url;
    }

    this.contactUsService.openContactUs(null, message);
  }
}

